<template>
  <generic-modal
    :title="$t('example code')"
    icon="code"
    image="/images/icons/code.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
    :show_cancel="false"
  >
    <div class="description">
      <code-editor
        v-model="example_code"
        :type="type"
        icon="code"
        theme="monokai"
        :title="$t('example code')"
      ></code-editor>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import CodeEditor from "@/components/code_editor/Index";

export default {
  name: "ExampleCodeModal",
  components: {
    "generic-modal": GenericModal,
    CodeEditor,
  },
  props: { example_code: String, type: String },
  data() {
    return {
      // example_code: "",
    };
  },
  methods: {
    finished() {
      return new Promise(function(resolve) {
        resolve();
      });
    },
    destroy() {
      this.$emit("destroy");
    },
    show(code) {
      this.example_code = code;
    },
  },
  mounted() {},
  created() {},
  updated: function() {},
};
</script>
